import {copilot} from '@cl/shared';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import routingService from 'common/src/modules/routing/routing.service';
import {CLStore} from 'common/src/redux/store';
import generalAgent from '../agents/generalAgent';
import skillsAgent from '../agents/skills__agent';
import supportAgent from '../agents/supportAgent';
import generalNavigationSkill from '../skills/definitions/generalNavigationSkill/generalNavigationSkill';
import {registerSkill} from '../skills/skillRegistry';
import {registerUniversalTools} from '../tools/toolRegistry';

export default function initializeCopilot(store: CLStore) {
  const isSkillsMode = isFlagEnabled(FeatureFlagKey.EnableCopilotSkills);

  if (isSkillsMode) {
    // When skills mode is in, move this to the general initializeApp
    routingService.initializeHistoryTracking();

    registerUniversalTools(store);
    copilot.registerAgent(skillsAgent(store));
    registerSkill(generalNavigationSkill(store));
  } else {
    copilot.registerAgent(generalAgent(store));
    copilot.setSupportAgent(supportAgent(store));
  }
}
